import styled from "styled-components";

export const Section = styled.section`
	padding: 4rem 0;
	background-color: #f9fafb;

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1rem;
	}

	.text-center {
		text-align: center;
		margin-bottom: 3rem;
	}
`;

export const SectionTitle = styled.h2`
	font-size: 2rem;
	font-weight: 700;
	color: #1a1a2e;
	margin-bottom: 0.5rem;

	@media (min-width: 768px) {
		font-size: 2.5rem;
	}
`;

export const SectionSubtitle = styled.p`
	color: #6b7280;
	max-width: 600px;
	margin: 0.75rem auto 0;
	font-size: 1rem;
	line-height: 1.6;
`;

export const TestimonialsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 1.5rem;

	@media (min-width: 768px) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

export const TestimonialCard = styled.div`
	padding: 1.5rem;
	border-radius: 0.75rem;
	background-color: #fff;
	border: 1px solid #e5e7eb;
	transition: box-shadow 0.2s;

	&:hover {
		box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
	}

	.quote {
		font-size: 0.9rem;
		color: #6b7280;
		line-height: 1.6;
		font-style: italic;
		margin-bottom: 1rem;
	}
`;

export const Stars = styled.div`
	display: flex;
	gap: 0.25rem;
	margin-bottom: 1rem;
	color: #facc15;
	font-size: 0.9rem;
`;

export const Avatar = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;

	.name {
		font-size: 0.9rem;
		font-weight: 600;
		color: #1a1a2e;
	}

	.role {
		font-size: 0.8rem;
		color: #6b7280;
	}
`;

export const AvatarCircle = styled.div`
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 50%;
	background-color: rgba(100, 43, 115, 0.1);
	color: #642b73;
	font-weight: 700;
	font-size: 0.9rem;
	display: flex;
	align-items: center;
	justify-content: center;
`;
